import React from 'react';

const GenerationText = ({
  x,
  y,
  size,
  fontFamily='Montserrat',
  fontSize=36,
  fill,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="500" height="40" viewBox="0 0 500 40">
    <text textLength='290' lengthAdjust="spacing" x='5' y="14" fill={fill} fontSize={fontSize} fontFamily={fontFamily}>
      Geneology
    </text>
  </svg>
)
export default GenerationText;


// WEBPACK FOOTER //
// ./src/core/add-ons/geneology.js